module.exports = __webpack_public_path__ + "static/media/karl_straub.846bb8b2.jpg";